export default __webpack_public_path__ + "static/media/xpensityV1-tablet-main.ff03260c.webp";